import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import { ICenter, IVoucherCardProduct, IVoucherProduct, ProductType } from '../interfaces';
import PlaceholderView from './placeholder-view';
import '../styles/voucher-list.css';

interface VoucherListProps {
  selectedCenter: ICenter;
}

type IGeneralVoucherProduct = IVoucherProduct | IVoucherCardProduct;

const VoucherList: React.FC<VoucherListProps> = (props) => {
  const { selectedCenter } = props;
  const [vouchers, setVouchers] = useState<IGeneralVoucherProduct[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const centerId = selectedCenter?.winticketId;

  useEffect(() => {
    const fetchVouchers = async () => {
      setIsLoading(true);

      const voucherData = (await api.retrieveProducts(selectedCenter?.winticketId, [
        ProductType.Voucher,
        ProductType.VoucherCard,
      ])) as IGeneralVoucherProduct[];

      if (voucherData) {
        setVouchers(voucherData);
      }

      setIsLoading(false);
    };

    fetchVouchers();
  }, [selectedCenter]);

  if (isLoading) {
    return <PlaceholderView>Loading...</PlaceholderView>;
  }

  if (!vouchers?.length) {
    return <PlaceholderView>There are no vouchers configured for the center</PlaceholderView>;
  }

  return (
    <div className='voucher-list'>
      <h2>Vouchers (Api)</h2>
      {vouchers.map((voucher, i) => (
        <div className='voucher-item' key={`${voucher.productId}${i}`} style={{ padding: '5px' }}>
          <div className='voucher'>
            <Link
              className='voucher-link'
              to={{
                pathname: `/center/${centerId}/purchase-voucher`,
                state: { productId: voucher.productId },
              }}
            >
              {voucher.displayName}
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VoucherList;
